import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../../store/actions';
import { withRouter } from 'react-router';
import { API, CURRENCY } from '../../../../constants';
import { formatMoney } from '../../../../services';
import { formatDate, StringToNumber } from '../../../../utils/';
import classNames from 'classnames';
import _ from 'lodash';
import hideTaxId from '../../../../utils/hideData';

export class PurchaseItemPurchase extends Component {
  handleProduct = async (itemSelected) => {
    const { updateWording, getItemById } = this.props;
    const itemName = itemSelected.productName.split('-').join(' ');
    await updateWording();
    await getItemById(itemName, 'buyAgain');
    this.handleBuyAgain(itemSelected);
  };

  handleBuyAgain = async () => {
    let qty = 1;

    const {
      firebaseAuth,
      OpenDialogLogin,
      cart,
      CreateCart,
      AddOrUpdateProductToCart,
      GetCartData,
      history,
      product,
      type,
      AddToBuyNow,
      basenameURL,
      overStock
    } = this.props;

    const { items } = product;

    const colors = _.chain(items)
      .groupBy('colorCode')
      .map((value, name) => ({ name }))
      .value();

    const orderBy = ['S', 'M', 'L', 'XL'];
    const itemSort = items.sort(
      (a, b) => orderBy.indexOf(a.sizeName) - orderBy.indexOf(b.sizeName)
    );

    const itemSelected = this.filterItemSelected(itemSort);

    if (firebaseAuth) {
      const FindItemInCart = _.filter(
        cart,
        (item) => item.itemId === itemSelected.id
      );

      const AmountOfItemInCart =
        FindItemInCart.length === 0 ? 0 + qty : FindItemInCart[0].qty + qty;

      if (AmountOfItemInCart > itemSelected.stock) {
        overStock();
        this.handleDialogProductOverStock();
      } else {
        const model = {
          itemId: itemSelected.id,
          itemName: itemSelected.productName,
          sizeName: itemSelected.sizeName,
          qty: qty,
          rgbColor: itemSelected.color,
          promotionPrice: itemSelected.promotionPrice,
          price: itemSelected.price,
          itemStock: itemSelected.stock,
          cartItemImage: itemSelected.pictures[0],
          promotionCodeDirect: itemSelected.promotionCodeDirect,
          promotionCodeDiscountCode: itemSelected.promotionCodeDiscountCode,
          dimension: itemSelected.dimension || 0
        };

        if (type !== "voucher") {
          if (cart.length === 0) {
            await CreateCart(model, 'buynow');
          } else {
            await AddOrUpdateProductToCart(model, 'buynow');
          }
          await GetCartData();
        } else {
          AddToBuyNow({ ...model, type: "voucher" });
        }
        await this.setState({ qty: 1 });
        await history.push(`${basenameURL}/cart`);
      }
    } else {
      OpenDialogLogin();
    }
  };

  filterSizeSelected = (items, color) => {
    const orderBy = ['S', 'M', 'L', 'XL'];
    return _.chain(items)
      .filter((item) => item.colorCode == color)
      .groupBy('sizeName')
      .map((value, key) => key)
      .value()
      .sort((a, b) => orderBy.indexOf(a) - orderBy.indexOf(b));
  };

  filterItemSelected = (data) => {
    let itemSelected = null;
    data.some((itemData) => {
      itemSelected = itemData;
      if (itemData.stockAvailable > 0) {
        return true;
      }
      return false;
    });

    return itemSelected;
  };

  createLightBoxSource = (data) => {
    const source = data.map((d) => {
      return `${API.PRODUCT_IMG_URL}${d}`;
    });
    return source;
  };

  handleDialogProductOverStock = () => {
    const { CloseDialogProductOverStock } = this.props;
    setTimeout(() => {
      CloseDialogProductOverStock();
    }, 1500);
  };

  render() {
    const { wording, history, item, review, currentLanguage } = this.props;

    const total = StringToNumber(item.total);
    const shippingCost = StringToNumber(item.shippingCost);
    const subTotal = StringToNumber(item.subTotal);
    const discount = StringToNumber(item.discount);

    const product = item;

    return (
      <div className="content-warpper col-md-12 col-xs-12 product product-grid pt-10 pb-10 ml-10 mr-10">
        <div>
          <p className="mr-10 top-detail-user">
            <span className="caption white mr-10">
              {wording.purchase.invoiceNo}
            </span>
            <span className="white mr-10">{item.invoice}</span>
            <span className="caption white mr-10">
              {wording.purchase.orderDate}
            </span>
            <span className="white mr-10">{item.date}</span>
          </p>
          <p>
            <span className="caption white mr-10">
              {wording.purchase.status}
            </span>
            <span
              className={classNames(
                {
                  'status-failed': item.status === 'FAILED',
                  'status-pending': item.status === 'PENDING',
                  'status-shipping': item.status === 'SHIPPING',
                  'status-received': item.status === 'DELIVERED'
                },
                'mr-10'
              )}>
              {wording.usermenu.purchase[item.status.toLowerCase()]}
            </span>
            {item.deliveryNumber !== '' && (
              <>
                <span className="caption white mr-10">
                  {wording.purchase.deliveryNo}
                </span>
                <span className="kerry-tracking mr-10">
                  {item.deliveryNumber}
                </span>
              </>
            )}
          </p>
        </div>
        {/* Table list item */}
        <div className="table-wrap" style={{ backgroundColor: 'black' }}>
          <table className="shop_table cart table">
            <thead>
              <tr>
                <th className="product-name white" colSpan="2">
                  {wording.purchase.product}
                </th>
                <th className="product-price white">
                  {wording.purchase.price}
                </th>
                <th className="product-quantity white">
                  {wording.purchase.quantity}
                </th>
                <th className="product-subtotal white">
                  {wording.purchase.total}
                </th>
              </tr>
            </thead>
            <tbody>
              {item.orderDetail.map((item) => {
                const price = StringToNumber(item.price);
                const totalPrice = StringToNumber(item.totalPrice);
                return (
                  <Fragment key={`order-${item.id}`}>
                    <tr className="cart_item">
                      <td className="product-thumbnail">
                        <img
                          className="pl-10"
                          src={`${API.PRODUCT_IMG_URL}${item.picture}`}
                          alt={item.picture}
                        />
                      </td>

                      <td className="product-name">
                        <a className="white">{item.productName}</a>
                        <ul>
                          {item.productSizeName !== 'N' && (
                            <li className="white">{`${wording.checkoutPage.checkout.size}: ${item.productSizeName}`}</li>
                          )}

                          {item.color && (
                            <li>
                              <div
                                style={{
                                  display: 'flex'
                                }}
                                className="color-select clearfix">
                                <span
                                  style={{ marginTop: 0, marginRight: 4 }}
                                  className="white">
                                  {wording.purchase.color}
                                </span>
                                <ul className="color-swatches clearfix">
                                  <li>
                                    <a
                                      style={{
                                        backgroundColor: item.color,
                                        width: 18,
                                        height: 18
                                      }}
                                    />
                                  </li>
                                </ul>
                              </div>
                            </li>
                          )}
                        </ul>
                      </td>

                      <td className="product-price">
                        <span className="amount white">
                          {`${CURRENCY.B}${formatMoney(price)}`}
                        </span>
                      </td>

                      <td className="product-price">
                        <span className="amount white">{item.amount}</span>
                      </td>

                      <td className="product-subtotal">
                        <span className="amount white">
                          {`${CURRENCY.B}${formatMoney(totalPrice)}`}
                        </span>
                      </td>
                    </tr>

                    {product &&
                      product.status === 'DELIVERED' && ( // DELIVERED
                        <tr>
                          <td colSpan="5">
                            {!item.reviewPoint && (
                              <button
                                className={
                                  !item.reviewPoint
                                    ? 'btn btn-md btn-color'
                                    : 'btn btn-md btn-light'
                                }
                                style={{ marginRight: 10 }}
                                disabled={item.reviewPoint}
                                onClick={() => review(item)}>
                                {wording.purchase.buttonRating}
                              </button>
                            )}
                            <button
                              className="btn btn-md btn-light"
                              onClick={() => this.handleProduct(item)}>
                              {wording.purchase.buttonBuyAgain}
                            </button>
                          </td>
                        </tr>
                      )}
                  </Fragment>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-8">
            <p className="mt-10">
              <span className="caption white mr-10">
                {wording.purchase.shippingAddress}
              </span>
              <span className="white">{`${item.name} ${item.lastName} ${item.phoneNumber}`}</span>
              <br />
              {
                item.deliveryType == "Branch"
                  ? <>
                    <span className="caption white mr-10">{wording.purchase.pickUpBranch} </span><span className="white">{item.branchName}</span>
                    {/* <br />
                      <span className="caption white mr-10">{wording.purchase.since} </span><span className="white">{formatDate(item.pickUpDate)[currentLanguage]}</span> */}
                  </>
                  : <span className="white">{`${item.address ?? ''} ${item.subDistrict ?? ''} ${item.district} ${item.province} ${item.zipCode}`}</span>
              }
            </p>
            {item.taxIsRequest === 'Y' && (
              <p className="mt-10">
                <span className="caption white mr-10">
                  {wording.purchase.taxInvoiceAddress}
                </span>
                <span className="white">{`${item.taxName} ${item.taxLastName} ${hideTaxId(item.taxId)}`}</span>
                <br />
                <span className="white">{`${item.taxAddress ?? ''} ${item.taxSubDistrict ?? ''} ${item.taxDistrict} ${item.taxProvince} ${item.taxZipCode}`}</span>
                <br />
                <span className="white">{`${item.taxPhoneNumber} ${item.taxEmail}`}</span>
              </p>
            )}
          </div>
          <div className="col-xs-12 col-md-4">
            <div
              className="ecommerce-checkout-review-order mr-10"
              id="order_review">
              <table className="table shop_table ecommerce-checkout-review-order-table">
                <tbody>
                  <tr className="cart-subtotal">
                    <th className="white">{wording.purchase.subtotal}</th>
                    <td>
                      <span className="amount white">
                        {`${CURRENCY.B}${formatMoney(subTotal)}`}
                      </span>
                    </td>
                  </tr>
                  <tr className="shipping">
                    <th className="white">{wording.purchase.shipping}</th>
                    <td>
                      <span className="white">
                        {`${CURRENCY.B}${formatMoney(shippingCost)}`}
                      </span>
                    </td>
                  </tr>
                  {discount > 0 && (
                    <tr className="shipping">
                      <th className="white">{wording.purchase.discount}</th>
                      <td>
                        <span className="white">
                          {`${CURRENCY.B}${formatMoney(discount)}`}
                        </span>
                      </td>
                    </tr>
                  )}
                  <tr className="order-total">
                    <th className="white">
                      <strong>{wording.purchase.total}</strong>
                    </th>
                    <td>
                      <strong>
                        <span className="amount white">
                          {`${CURRENCY.B}${formatMoney(total)}`}
                        </span>
                      </strong>
                    </td>
                  </tr>
                  {item.status === 'DELIVERED' &&
                    !item.refund &&
                    item.refundTime && (
                      <tr>
                        <td colSpan={2}>
                          <button
                            className="btn btn-md btn-light mt-20"
                            onClick={() =>
                              history.push(`/user/returnorder/${item.orderId}`)
                            }>
                            {wording.usermenu.purchase.return}
                          </button>
                        </td>
                      </tr>
                    )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ login, product, cart, language, navigation }) => ({
  firebaseAuth: login.firebaseAuth,
  product: product.data,
  dialogStock: product.dialogStock,
  dialogAddProductToCart: cart.dialogAddProductToCart,
  cart: cart.data,
  wording: language.wording,
  currentLanguage: language.currentLanguage,
  navbarCategory: navigation.navbarCategory,
  basenameURL: language.basenameURL
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateWording: Actions.updateWording,
      OpenDialogLogin: Actions.OpenDialogLogin,
      CreateCart: Actions.CreateCart,
      AddOrUpdateProductToCart: Actions.AddOrUpdateProductToCart,
      GetCartData: Actions.GetCartData,
      AutoCloseDialogAddProductToCart: Actions.AutoCloseDialogAddProductToCart,
      OpenDialogProductOverStock: Actions.OpenDialogProductOverStock,
      CloseDialogProductOverStock: Actions.CloseDialogProductOverStock,
      getItemById: Actions.getItemById,
      AddToBuyNow: Actions.AddToBuyNow
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PurchaseItemPurchase)
);
